import { PaymentInfoDto, UpdatePaymentDto, ProcessPaymentDto, RefundPaymentDto } from '../dto';
import { PaymentStatus, PaymentMethod } from '../enums/order-item-type.enum';

/**
 * Example: Cash Payment
 */
export const exampleCashPayment: PaymentInfoDto = {
  paymentStatus: PaymentStatus.PENDING,
  paymentMethod: PaymentMethod.CASH,
  cashPayment: 150.00,
  notes: 'Cash payment to be collected on delivery'
};

/**
 * Example: Credit Card Payment
 */
export const exampleCreditCardPayment: PaymentInfoDto = {
  paymentStatus: PaymentStatus.PAID,
  paymentMethod: PaymentMethod.CREDIT_CARD,
  transactionId: 'txn_1234567890',
  gatewayReference: 'stripe_pi_1234567890',
  paidAt: new Date().toISOString()
};

/**
 * Example: Bank Transfer Payment
 */
export const exampleBankTransferPayment: PaymentInfoDto = {
  paymentStatus: PaymentStatus.PENDING,
  paymentMethod: PaymentMethod.BANK_TRANSFER,
  notes: 'Bank transfer payment - waiting for confirmation'
};

/**
 * Example: Failed Payment
 */
export const exampleFailedPayment: PaymentInfoDto = {
  paymentStatus: PaymentStatus.FAILED,
  paymentMethod: PaymentMethod.CREDIT_CARD,
  transactionId: 'txn_failed_1234567890',
  notes: 'Payment failed due to insufficient funds'
};

/**
 * Example: Refunded Payment
 */
export const exampleRefundedPayment: PaymentInfoDto = {
  paymentStatus: PaymentStatus.REFUNDED,
  paymentMethod: PaymentMethod.CREDIT_CARD,
  transactionId: 'txn_1234567890',
  gatewayReference: 'stripe_pi_1234567890',
  paidAt: '2024-01-15T10:30:00.000Z',
  refundAmount: 50.00,
  refundedAt: '2024-01-20T14:30:00.000Z',
  notes: 'Partial refund due to product defect'
};

/**
 * Example: Update Payment Status
 */
export const exampleUpdatePayment: UpdatePaymentDto = {
  paymentStatus: PaymentStatus.PAID,
  paidAt: new Date().toISOString(),
  notes: 'Payment confirmed via bank transfer'
};

/**
 * Example: Process Payment
 */
export const exampleProcessPayment: ProcessPaymentDto = {
  paymentMethod: PaymentMethod.CASH,
  amount: 150.00,
  notes: 'Cash payment received at store'
};

/**
 * Example: Refund Payment
 */
export const exampleRefundPayment: RefundPaymentDto = {
  refundAmount: 25.00,
  reason: 'Customer requested refund due to product defect',
  notes: 'Partial refund processed via original payment method'
};